<script setup lang="ts">
import ProjectTableCell from '@/modules/Project/ProjectTableCell.vue'
import TableCell from '@/modules/Project/TableCell.vue'
import { computed } from 'vue'
import { useProjectStore } from './useProjectStore'

const props = defineProps<{
  rowIndex: number
  colIndex: number
  rowIsSelected: boolean
  isRowHovered: boolean
}>()

const emit = defineEmits<{
  (e: 'next', event?: KeyboardEvent): void
}>()

const projectStore = useProjectStore()

const entity = computed(() => projectStore.activeView?.entities?.[props.rowIndex])
</script>

<template>
  <ProjectTableCell
    v-if="entity"
    :row-index="rowIndex"
    :row-is-selected="rowIsSelected"
    :col-index="colIndex"
    :is-row-hovered="isRowHovered"
    @next="emit('next', $event)"
  />
  <TableCell
    v-else
    :is-focused="false"
    :is-selected="false"
    :is-in-selected-range="false"
    :loading="true"
  />
</template>
